<template>
  <div class="onboarding-step">
    <div class="onboarding-step__wrap">
      <ProfileConnect @connect="initPlatformConnect" :platform="initPlatform" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import { mapState } from "vuex";

import ProfileConnect from "@/components/Onboarding/ProfileConnect.vue";

export default {
  components: {
    ProfileConnect
  },
  computed: {
    ...mapState({
      platformSession: state => state.platformSession,
      initPlatform: state => state.initPlatform,
      game: state => state.game
    })
  },

  mounted() {
    if (!this.initPlatform) {
      this.$router.push({ name: `${this.game}` });
    }
  },

  methods: {
    initPlatformConnect(platform) {
      if (this.platformSession && this.platformSession.token) {
        this.autoLinkWithPlatform();
      } else {
        this.connect(platform);
      }
    },
    autoLinkWithPlatform() {
      if (this.platformSession && this.platformSession.token) {
        console.log(
          "Platform session: ",
          this.platformSession.platform,
          this.platformSession.gameId,
          this.platformSession.token
        );

        switch (this.platformSession.platform) {
          case "steam":
            this.$store
              .dispatch("steamAutoLink", {
                token: this.platformSession.token,
                gameId: this.platformSession.gameId
              })
              .then(res => {
                this.$store.dispatch("setStep", 4);
                console.log("LINK RES: ", res);
              })
              .catch(e => {
                this.connect("steam");
                console.log("ERROR: ", e);
              });
            break;
          case "galaxy":
            this.$store
              .dispatch("galaxyAutoLink", {
                token: this.platformSession.token,
                gameId: this.platformSession.gameId
              })
              .then(res => {
                this.$store.dispatch("setStep", 4);
                console.log("LINK RES: ", res);
              })
              .catch(e => {
                this.connect("galaxy");
                console.log("ERROR: ", e);
              });
            break;
        }
      }
    },

    async connect(key) {
      switch (key) {
        case "steam":
          await this.$store.dispatch("steamConnect", { app: "launcher" });
          break;

        case "galaxy":
          await this.$store.dispatch("galaxyConnect", { app: "launcher" });
          break;
        default:
          return false;
      }
    }
  }
};
</script>
